import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { MaintenanceSearchByTextDto } from '@shared/src/controllers/maintenance/_base/MaintenanceSearchByTextDtos';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { MultiSelectDto } from '@shared/src/dtos/booking/MultiSelectDto';
import { SharedAsideFactory } from '@shared/src/public-api';

@Component({
	selector: 'shared-active-bookings-item-conflict',
  	templateUrl: './shared.active.bookings.item.conflict.html',
  	styleUrls: ['./shared.active.bookings.item.conflict.scss']
})
export class SharedActiveBookingsItemConflict implements OnInit {

	public useIonic: boolean = false;
	constructor(public activatedRoute: ActivatedRoute,
		public router: Router, public bookingController: BookingController, 
		@Inject('HomeController') protected homeController: HomeController,
		@Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory,
		protected socketController: SocketController) {

		this.socketController.notificationReloadHome$.subscribe(e => {
			this.loadData(false);
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}
	
  	@Input() public readonly: boolean;

	public searchText: string = "";

	public selectedRoutes: Array<number> = [];

	public conflictiveRoutes: Array<RouteCardItemDto> = [];

  	public filterMetadataRoutes: any = {};

	public showingSelectedRoutes = false;
	public actions: ActionsStripDto;
	
  	public confirmRoutesActions: ActionsStripDto;

	@Output() finishConflictRoutes = new EventEmitter<boolean>();

	ngOnInit(): void {
	
	}

	public allLoaded: boolean = false;
	
	public _bookingId: number;
	@Input()
	public get bookingId(): number {
		return this._bookingId;
	}
	public set bookingId(value: number) {
		if (this._bookingId === value)
			return;
		this._bookingId = value;
		this.loadData(true);
	}


	ngAfterViewChecked(): void {
	}


  	public filter: MaintenanceSearchByTextDto = new MaintenanceSearchByTextDto();
	loadData(busy: boolean) {

		//Si tenim ruta seleccionada, no te sentit fer cerca total
		if (HLong.isNullOrNullLong(this.bookingId))
			return;

		this.selectedRoutes = [];
		this.showingSelectedRoutes = false;
		this.filter.searchtext = this.searchText;

		this.bookingController.getConflictiveRouteItems(this.bookingId).subscribe(e => {
			if (e) {
				this.conflictiveRoutes = e;
				this.allLoaded = true;				
			}
		});

	}	

	getSelectedRoutes() {
		return this.conflictiveRoutes.filter(r => this.selectedRoutes.includes(r.routeId));
	}

	onSelectRoute(item: RouteCardItemDto) {
		if (this.selectedRoutes.includes(item.routeId))
		this.selectedRoutes.splice(this.selectedRoutes.indexOf(item.routeId), 1);
		else
		this.selectedRoutes.push(item.routeId);

		this.loadActions();
	}
	
	public loadActions() {
		this.actions = new ActionsStripDto();
		this.actions.add(ActionDto.buildAdd("SELECTALL", "BOOKINGPAGE.SELECTALL.CAPTION", null, null, 0, -1, 1, null));
		this.actions.add(ActionDto.build("DESELECTALL", "BOOKINGPAGE.DESELECTALL.CAPTION", null, null, 1, -1, 1, null));
	
		let showNext: boolean = this.selectedRoutes && this.selectedRoutes.length > 0;
	
		if (showNext)
		  this.actions.add(ActionDto.buildAdd("NEXT", "MAINTENANCE.NEXT", null, "fa-arrow-right", 2, 0, 1, null));
	
		this.confirmRoutesActions = new ActionsStripDto();
		this.confirmRoutesActions.add(ActionDto.build("CANCEL", "BOOKINGPAGE.CANCEL.CAPTION", null, null, 0, -1, 1, null));
		this.confirmRoutesActions.add(ActionDto.buildAdd("CONFIRM", "BOOKINGPAGE.CONFIRM.CAPTION", null, null, 1, -1, 1, null));
	}


	public onClickAction(item: ActionDto) {
		if (!item)
		  return;
	
		switch (item.actionId) {
			case "SELECTALL":
				this.selectedRoutes = [];
				if (this.filterMetadataRoutes.items)
				this.selectedRoutes = this.filterMetadataRoutes.items.map((r: RouteCardItemDto) => r.routeId);
				this.loadActions();
				break;
			case "DESELECTALL":
				this.selectedRoutes = [];
				this.loadActions();
				break;
			case "NEXT":
				this.showingSelectedRoutes = true;
				break;
			case "CONFIRM":
				let msReleaseDto: MultiSelectDto = MultiSelectDto.build(this.selectedRoutes);
				this.bookingController.multiReleaseBooking(this.bookingId, msReleaseDto).subscribe(e => {
					if (e) {
						// Buidem les dades del procés
						this.selectedRoutes = [];
						this.showingSelectedRoutes = false;
						this.finishConflictRoutes.next(true);

					}
				});
			break;
			case "CANCEL":
				this.showingSelectedRoutes = false;
				break;
			default:
			break;
		}
	}

	onDoubleClickRoute(route: RouteCardItemDto) {
	if (route == null)
		return;

		//this.sharedAsideFactory.invokeBookingRoute(route).then(value => {
			//this.getBookingRoutes();
			//this.getConflictiveRoutes();
			//this.getPendingRoutes(false);
			//this.reloadBooking();
		//});
	}
	

	pretty(value) {
		return JSON.stringify(value);
	}
}
